// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import setDisplayedWidgetName from "@insite/client-framework/Store/Pages/BudgetManagement/Handlers/SetDisplayedWidgetName";
import { getCurrentEditingUser } from "@insite/client-framework/Store/Pages/UserSetup/UserSetupSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { formGridProps } from "@store/Themes/common/props/form";
import useBudgetRules from "@store/Framework/Common/Hooks/useBudgetRules";
import { hasRoleWithAllowances } from "@store/Framework/Common/Utilities/customerUtilities";
import getWidgetComponent from "@toolkit/Framework/Common/Utilities/getWidgetComponent";
import React, { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";

const AssignBudgets = getWidgetComponent("Budget/AssignBudgets");

const mapStateToProps = (state: ApplicationState) => ({
    billToState: getCurrentBillToState(state),
    editingUser: getCurrentEditingUser(state),
});

const mapDispatchToProps = {
    setDisplayedWidgetName,
};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface UserSetupBudgetAssignementStyles {
    title?: TypographyPresentationProps;
    container?: GridContainerProps;
    gridItem?: GridItemProps;
}

export const userSetupBudgetAssignementStyles: UserSetupBudgetAssignementStyles = {
    title: formGridProps.title,
    container: formGridProps.gridContainer,
    gridItem: { width: [12, 12, 12, 12, 12] },
};

const styles = userSetupBudgetAssignementStyles;

const UserSetupBudgetAssignement = ({ billToState, editingUser, setDisplayedWidgetName }: Props) => {
    const { budgetManagementEnabled, hasUserEnforcementLevel } = useBudgetRules();

    useEffect(() => {
        setDisplayedWidgetName({ value: "AssignBudgets" });
    }, []);

    if (
        !editingUser ||
        !budgetManagementEnabled ||
        !hasRoleWithAllowances(editingUser.role) ||
        billToState.isLoading ||
        !billToState.value ||
        !hasUserEnforcementLevel
    ) {
        return null;
    }

    return (
        <>
            <Typography {...styles.title}>{translate("Assign Budget")}</Typography>
            <GridContainer {...styles.container}>
                <GridItem {...styles.gridItem}>
                    <AssignBudgets />
                </GridItem>
            </GridContainer>
        </>
    );
};
const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(UserSetupBudgetAssignement),
    definition: {
        group: "User Setup",
        displayName: "User Budget",
        allowedContexts: ["UserSetupPage"],
    },
};

export default widgetModule;
